import React from 'react'
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

const BarChart = ({ data }) => {

    const chartData = {
        labels: [[ data.actual, "Actual" ], [ data.goal, "Goal" ] ],
        datasets: [{
            data: [ data.actual, data.goal ],
            backgroundColor: [ '#669771', '#0E3531' ],
            barThickness: 50,
            minBarLength: 20,
            borderSkipped: true,
        }],
    };

    const options = {
        indexAxis: 'x',
        elements: {  bar: { borderWidth: 2 } },
        responsive: true,
        maintainAspectRatio: false,
        scales: { 
            y: { beginAtZero: true, border: { display: false }, ticks: { font: { size: 10 } }}, 
            x: { beginAtZero: true, grid: { display: false}, border: { display: false }, ticks: { font: { size: 12, weight:"500", family: "Inter", } }}, 
        }, 
        plugins: {
            tooltip: { enabled: false },
            legend: { display: false },
            title: { display: true, text: data.name, font: { family: "Inter", weight: "500" } },
            datalabels: {
                formatter: function(value, context) {
                    if (context.dataset.data[context.dataIndex] === 0) return 0;
                    if (context.dataIndex === 1) return "";
                    if (context.dataIndex === 0 && context.dataset.data[1] === 0) return "";
                    const percentage = (context.dataset.data[0] / context.dataset.data[1]) * 100;
                    return percentage.toFixed(0) + '%';
                },
                color: 'white',
                font: {
                  weight: 'light',
                },
            }
        },
    };
    
    return <Bar options={options} data={chartData} height={200} />
}
export default BarChart;